export enum ThemeColorEnum {
  SURFACE_VARIANT,
  ON_SURFACE_VARIANT,
  CUSTOM_BLUE,
  CUSTOM_RED,
  CUSTOM_YELLOW,
  CUSTOM_GREEN,
  SURFACE,
  SURFACE_CONTAINER,
  ON_SECONDARY_CONTAINER,
  ON_TERTIARY_CONTAINER,
  ON_SURFACE,
  PRIMARY,
  ON_PRIMARY,
  INVERSE_ON_SURFACE,
  ERROR,
}

export enum ThemeIconSizeEnum {
  EXTRA_SMALL = 20,
  SMALL = 24,
  LARGE = 32,
  EXTRA_LARGE = 40,
  EXTRA_EXTRA_LARGE = 56,
}

export enum ThemeIconEnum {
  ADD,
  APPS,
  ARROW_BACK,
  ARROW_DROP_DOWN,
  ARROW_FORWARD,
  BUILD,
  CALENDAR_MONTH,
  CHECK,
  CHEVRON_LEFT,
  CHEVRON_RIGHT,
  CLOSE,
  CLOSE_FULLSCREEN,
  CLOUD_OFF,
  DATABASE,
  DOWNLOAD,
  ERROR,
  FULLSCREEN,
  GROUPS,
  HISTORY,
  HOME,
  KEYBOARD,
  LOCAL_BAR,
  LOGOUT,
  MAP,
  MENU,
  MORE_VERT,
  NAVIGATION,
  OPEN_IN_FULL,
  PALLETE,
  PERSON,
  PLAY_CIRCLE,
  PRINT,
  PUBLISH,
  RESTAURANT,
  SCHEDULE,
  SETTINGS,
  SPORTS_BAR,
  SPORTS_ESPORTS,
  SYNC,
  UPLOAD,
  WAREHOUSE,
  WARNING,
}

export enum ComponentStateEnum {
  ENABLED,
}
